<template>
  <section class="search-section px-10 mb-4">
    <h1 class="text-primary text-center mt-8 mb-5">
      {{ $t('searchPage.title') }}
    </h1>
    <MainSearchBar />
  </section>
  <v-sheet class="filters bg-white px-sm-10 my-0">
    <v-container class="d-flex align-center px-0 px-md-0 my-0 py-0">
      <!-- <v-slide-group show-arrows class="w-100"> -->

      <SearchFilters class="mr-2" />
      <!-- <ExtraFilterAvailabilities class="mr-2" />

        <ExtraFilterServices class="mr-2" />

        <ExtraFilterRemote /> -->
      <!-- </v-slide-group> -->
    </v-container>
  </v-sheet>
  <div
    v-if="smAndDown"
    class="mb-4 px-6 d-flex align-center justify-space-between"
  >
    <span class="font-weight-bold">
      <!-- {{ $t('searchPage.countResults', { count: countResults }) }} -->
    </span>
    <v-btn id="display-card" variant="text" color="blue">
      <img
        :src="mapIcon"
        alt="Map icon"
        width="30"
        height="30"
        class="rounded mr-2"
      />
      {{ $t('searchPage.displayMap') }}
      <v-dialog id="dialog-map" activator="parent">
        <v-card><LeafletMapSearchPage /></v-card>
      </v-dialog>
    </v-btn>
  </div>
  <v-container
    class="py-0"
    :class="{ 'opacity-0': mainSearchBarStore.loadingFind }"
  >
    <template v-if="mainSearchBarStore.listPractitioners.length">
      <template
        v-if="
          (mainSearchBarStore.searchService ||
            searchFilters.selectedDiscipline) &&
          mainSearchBarStore.searchLocation &&
          mainSearchBarStore.alreadySearchWithSelectedCity
        "
      >
        <p class="text-primary mb-4">
          {{
            $t('searchPage.resultSentenceWithDisciplineAndCity', {
              discipline:
                mainSearchBarStore.searchService ||
                searchFilters.selectedDiscipline,
              location: mainSearchBarStore.searchLocation,
            })
          }}
        </p>
      </template>

      <template
        v-else-if="
          (mainSearchBarStore.searchService ||
            searchFilters.selectedDiscipline) &&
          mainSearchBarStore.alreadySearchWithSelectedCity
        "
      >
        <p class="text-primary mb-4">
          {{
            $t('searchPage.resultSentenceWithDiscipline', {
              discipline:
                mainSearchBarStore.searchService ||
                searchFilters.selectedDiscipline,
            })
          }}
        </p>
      </template>

      <template
        v-else-if="
          mainSearchBarStore.searchLocation &&
          mainSearchBarStore.alreadySearchWithSelectedCity
        "
      >
        <p class="text-primary mb-4">
          {{
            $t('searchPage.resultSentenceWithCity', {
              location: mainSearchBarStore.searchLocation,
            })
          }}
        </p>
      </template>

      <template v-else-if="!!countResults">
        <p
          class="text-primary mb-4"
          v-html="$t('searchPage.resultSentence')"
        ></p>
      </template>
    </template>

    <p
      v-else-if="
        mainSearchBarStore.listPractitioners.length == 0 &&
        !mainSearchBarStore.loadingFind
      "
      class="text-primary mx-6 mx-md-12 mb-4"
    >
      {{ $t('searchPage.noResult') }}
    </p>
  </v-container>
  <v-container
    ref="mainContent"
    class="d-flex main-content w-100 px-6 pb-6 ga-6 w-100"
    style="position: relative"
    :class="{ 'flex-column-reverse': mdAndDown }"
  >
    <section id="practitioner-cards" class="flex-grow-1">
      <PractitionerCard
        v-for="(
          practitionerCardData, index
        ) in mainSearchBarStore.listPractitioners"
        :key="practitionerCardData.id"
        :id="practitionerCardData.id"
        :data="practitionerCardData"
        :is-in-three-last="
          index > mainSearchBarStore.listPractitioners.length - 3
        "
        class="mb-3"
      />
      <div class="w-100 d-flex justify-center">
        <v-btn
          v-if="mainSearchBarStore.loadingFind"
          icon
          variant="text"
          class="mx-auto"
          :loading="mainSearchBarStore.loadingFind"
        ></v-btn>
      </div>
    </section>
    <section
      v-if="!smAndDown"
      class="map-desktop d-flex flex-column justify-center min-w-25 flex-shrink-1 overflow-hidden"
    >
      <LeafletMapSearchPage />
      <div class="text-under-map">
        <router-link :to="{ name: 'Login' }">
          {{ $t('searchPage.TextUnderMap') }}
        </router-link>
      </div>
    </section>
  </v-container>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import MainSearchBar from '@/components/MainSearchBar/MainSearchBar.vue'
import mapIcon from '@/assets/search-page/mapIcon.png'
import { useDisplay } from 'vuetify'
import { useMainSearchBarStore } from '@/store/search-page/mainSearchBarStore'
import LeafletMapSearchPage from '@/components/search-page/LeafletMapSearchPage.vue'
import PractitionerCard from '@/components/search-page/PractitionerCard.vue'
// 3 commented lines under are features coming soon
import ExtraFilterAvailabilities from '@/components/MainSearchBar/ExtraFilterAvailabilities.vue'
import ExtraFilterServices from '@/components/MainSearchBar/ExtraFilterServices.vue'
import ExtraFilterRemote from '@/components/MainSearchBar/ExtraFilterRemote.vue'
import SearchFilters from '@/components/search-page/SearchFilters.vue'
import { useSearchFiltersStore } from '@/store/search-filters/searchFiltersStore'

const { smAndDown, mdAndDown } = useDisplay()
const mainSearchBarStore = useMainSearchBarStore()
const searchFilters = useSearchFiltersStore()

const countResults = computed(() => {
  return mainSearchBarStore.countResultsFound
})

const mainContent = ref<HTMLElement>()

const adjustMainContent = () => {
  if (!mainContent.value) return

  if (mdAndDown.value) {
    // go column with map at the beginning
    mainContent.value.classList.add('flex-column-reverse')
  } else {
    if (mainContent.value?.classList?.contains('flex-column-reverse')) {
      mainContent.value.classList.remove('flex-column-reverse')
    }
  }
}

window.onresize = _ => {
  adjustMainContent()
}
onMounted(() => {
  adjustMainContent()
})
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1280px) {
  .map-desktop {
    position: sticky;
    top: 100px;
    height: 460px;
  }
}
.text-under-map {
  padding: 0.5em;
  text-align: center;
}
.text-under-map a {
  text-decoration: none;
}
.search-section {
  min-height: 200px;
  background: #def2e7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.arrow-practitioner {
  height: 60px;
  width: 20px;
  top: -35px;
  margin-left: 50%;
  transform: translateX(-50%);
}

.card-availabilities {
  max-width: 400px;
}
.min-w-25 {
  min-width: 25%;
}
.main-content {
  margin-bottom: -270px;
}
</style>
